import { render, staticRenderFns } from "./EditCommunityDialog.vue?vue&type=template&id=4a0c8b92&scoped=true&"
import script from "./EditCommunityDialog.vue?vue&type=script&lang=js&"
export * from "./EditCommunityDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditCommunityDialog.vue?vue&type=style&index=0&id=4a0c8b92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0c8b92",
  null
  
)

export default component.exports